import React from 'react'
import './searchHeader.css'
import './subjects.css'
import {SearchBox} from '../../../../core/components/search-box/SearchBox'
import HeaderBlock from '../../../../core/components/header-block/HeaderBlock'
import GridContainer from '../../../../core/components/gridcontainer/GridContainer'
import illo1 from '../../../../core/img/homepage/expii_illo1_v3.png'
import headerPhoto from '../../../../core/img/homepage/expii_Photo_Edit_v3.png'
import {subjectToImageLight} from '../../../../core/less/SubjectToImage'
import {UniLink} from '../../../../core/components/unilink/index'

const subjectIcons = [
  [8951, 'Pre-Algebra'],
  [4106, 'Algebra 1'],
  [10005, 'Biology']
]

const SearchCard = ({navSearchEnabled, isLoggedIn, displayName }) => (
  <div>
    <HeaderBlock className="subjects-header">
      <div className='subjects-header__container'>
        <div className='subjects-header__left'>
          <img src={ headerPhoto } alt=''/>
        </div>
        <div className='ms-header'>
          <h1 className="ms-header__title">
            <div>Choose </div>
            <div className="ms-slider">
              <ul className="ms-slider__words">
                <li className="ms-slider__word">how</li>
                <li className="ms-slider__word">where</li>
                <li className="ms-slider__word">when</li>
                {
                  <li className="ms-slider__word">how</li>
                }
              </ul>
            </div>
            <div>you learn</div>
          </h1>
        </div>
      </div>
    </HeaderBlock>
    <div className='subjects__band'>
      <GridContainer>
        <div className='subjects-card subjects-card1'>
          <div className='subjects-card1-left'>
            <h2>Search 1000s of <span className='subjects-card1__h1-mobile-break'></span> Pre-Algebra, Algebra 1, and Biology Lessons</h2>
            <p>Explore our video, image, and text explanations to find the one that fits with you.</p>
            <div className='subject-search-container'>
              <SearchBox
                key='search-header-search'
                // className='search-header__search'
                id='search-header-search'
                isEntryPoint={!navSearchEnabled} /> 
            </div>
            <div className='subject-icons-container'>
              {
                subjectIcons.map(s => (
                  <div key={s[0]} className='subject-bar__subject'>
                    <UniLink
                      to={`/t/${s[0]}`}
                    >
                      <img className='subject-bar__subject-image' src={subjectToImageLight[s[0]]} alt='' />
                    </UniLink>
                    {
                      <span className='subject-bar__subject-name'>{s[1]}</span>
                    }
                  </div>
                ))
              }
            </div> 
          </div>
          <div className='subjects-card1-right'>
            <img className='' src={ illo1 } alt='' />
          </div>
        </div>
      </GridContainer>
    </div>
  </div>
)

export default SearchCard



// WEBPACK FOOTER //
// ./src/domains/home/subjects/components/SearchCard.js